<div *ngIf="!childConfig.isHidden" class="tml-tpl-ctrl-wrap" [style.width.px]="childConfig.css.width">
    <div class="tam-contact-control combine-control" attr.tid="{{config.typeTid}}">
        <kendo-dropdownlist [style.width.px]="childConfig.css.leftWidth" [popupSettings]="{appendTo: 'component'}"
            (valueChange)="valueChange($event)" [(ngModel)]="selectedItem" #dropDownEl [data]="suggestionItems"
            class="contact-dropdown" (focus)="dropDownEl.toggle(true)" (mousedown)="$event.preventDefault()">
        </kendo-dropdownlist>
        <div *ngIf="childConfig.config.isSupportDynamic" class="label-bac"
            [ngClass]="{'label-padding':childConfig.config.isSupportDynamic}" (click)="clickAddCtrol($event)">
            <label>{{childConfig.config.addlabel}}</label>
        </div>
    </div>

    <div class="tam-contact-control div-email-primary combine-control" (mouseenter)="mouseEnterLabel()"
        (mouseleave)="mouseLeaveLabel()" attr.tid="{{config.valueTid}}">
        <input class="tam-input" [(ngModel)]="inputValue" [style.width.px]="childConfig.css.rightWidth"
            [maxLength]='config.maxLength||128' [style.height.px]="config.height" [placeholder]="config.hint||''"
            (ngModelChange)="textChange($event)" [disabled]="config.isDisabled" (blur)="onBlur()" />
        <div class="hint-control">
            <label [hidden]="!hintContent" class="item-label-error">
                {{hintContent}}
            </label>

            <label [hidden]="isHidePrimary" class="item-label-email" [ngClass]="{'label-bac':!isPrimary}"
                (click)="clickSetPrimaryEmail()">{{isPrimary?"Primary":"Make
                Primary"}}</label>
        </div>

    </div>
    <div class="trash-icon">
        <smart-icon *ngIf="childConfig.config.isCanDelete" name="trash" (click)="clickRemoveLayout($event)">
        </smart-icon>
    </div>
</div>